import { DeviceContext } from '@/components/app/providers/deviceProvider/DeviceProvider'
import getPlatform from '@/helpers/getPlatform'
import { useContext } from 'react'

const useDevice = () => {
  const userAgent = useContext(DeviceContext)
  return { ...userAgent, PlatformType: getPlatform() }
}

export default useDevice
